const transactionStatuses = {
  failed: 'failed',
  success: 'success',
  processing: 'processing',
  pending: 'pending',
};

const transactionTypes = {
  internal: 'internal',
  external: 'external',
};

const batchType = {
  internal: 'internal',
  outbound: 'external',
  debits: 'debits',
};

const csvExample = {
  internal: '/batch.csv',
  outbound: '/outbound_batch.csv',
  debits: '/debits_batch.csv',
};

export { transactionStatuses, transactionTypes, batchType, csvExample };
